$('.prices-indi-js').each((key, pricesBlock) => {
  let $pricesBlock = $(pricesBlock);

  //bind language change
  $pricesBlock.find('.tabs-language-js li').click(function() {
    let languageId = parseInt(this.getAttribute('data-id'));
    setLanguage($pricesBlock, languageId);
  });
  $pricesBlock.find('.prices-indi__select select').change(function() {
    setLanguage($pricesBlock, parseInt(this.value));
  });

  //bind change teacher type
  let $teacherItems = $pricesBlock.find('.tabs-teacher-js li');
  $teacherItems.click(function() {
    let teacher = this.getAttribute('data-teacher');
    $teacherItems.removeClass('active');
    this.classList.add('active');
    setTeacher($pricesBlock, teacher);
  })
});

$('.indi-pay-js').click(function() {
  let $this = $(this);
  let $pricesBlock = $this.closest('.prices-indi-js');
  let lessonType = $this.data('id');
  let teacher = $pricesBlock.find('.tabs-teacher-js li.active').data('teacher');
  let format = $this.data('format');
  let tariff = $this.data('tariff');
  let language = $pricesBlock.find('.prices-indi__select select').val();

  openPaymentForm({
    lessonType,
    teacher,
    format,
    tariff,
    language,
  });
});

function setLanguage($pricesBlock, languageId) {
  $pricesBlock.find('.prices-indi__select select').val(languageId);
  $pricesBlock.find('.tabs-language-js li').removeClass('active');
  $pricesBlock.find(`.tabs-language-js li[data-id=${languageId}]`).addClass('active');
}

function setTeacher($pricesBlock, teacher) {
  $pricesBlock.find('.prices-indi__item').each((key, item) => {
    let $item = $(item);
    let price = $item.attr(`data-${teacher}-price`);
    let priceOld = $item.attr(`data-${teacher}-price-old`);
    let subtextBottom = $item.attr(`data-${teacher}-subtext_bottom`);
    let $priceBlock = $item.find('.price-item__price');

    //обновляем цены с анимацией
    $priceBlock.animate({opacity: 0}, 400);
    setTimeout(function() {
      $item.find('.price-old .data').text(priceOld.replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
      $item.find('.price .data').text(price.replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
      $priceBlock.animate({opacity: 1}, 400);
    }, 400);

    //обновляем текст снизу с анимацией
    let $subtextBottom = $item.find('.prices-indi__income');
    $subtextBottom.animate({opacity: 0}, 400);
    setTimeout(function() {
      $subtextBottom.html(subtextBottom);
      $subtextBottom.animate({opacity: 1}, 400);
    }, 400);
  });
}